import {Component, Input, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';
import {PostModel} from 'src/app/models/post.model';

@Component({
    selector: 'app-interacted-people',
    templateUrl: './interacted-people.component.html',
    styleUrls: ['./interacted-people.component.scss'],
    standalone: false
})
export class InteractedPeopleComponent implements OnInit {
  @Input() item: PostModel;

  showMoreBtn = false;
  showLessBtn = false;
  youSeeThisBecause = false;
  interactionSummary = 0;
  singleItem: any;
  singleInteraction = false;
  numberOfDifferentAction = 0;
  usersInteracted: number[] = [];
  numberOfDifferentUsers = 0;
  differentUsersInteracted = false;
  moreInteractionsThanUsers = false;
  lastInteractionType: string;

  constructor(private navController: NavController) {
  }

  ngOnInit() {
    this.filterActionFrom();
  }

  async openOtherProfile(id) {
    await this.navController.navigateForward(['/app/home/other-profile/' + id]);
  }

  async openInteraction(item, type) {
    const typeRefactor = (str) => {
      switch (str){
        case 'Like':{
          return 'like';
        }
        case 'Adopt': {
          return 'adopt'
        }
        case 'Rating': {
          return 'rate'
        }
        case 'Comment': {
          return 'comment'
        }
      }
    }
    await this.navController.navigateForward(['/app/home/interaction/' + item?.id + '/' + typeRefactor(type)]);
  }

  interactionIncluded(type: string) :boolean {
    return type === 'Like' || type === 'Adopt' || type === 'Rating' || type === 'Comment'
  }

  async openTeamProfile(t) {
    if (t.isAdmin) {
      await this.navController.navigateForward(['/app/team/view-team/' + t.id]);
    } else {
      await this.navController.navigateForward(['/app/team/other-team/' + t.id]);
    }
  }

  async openCompanyProfile(id) {
    await this.navController.navigateForward(['/app/team/company/other-company/' + id]);
  }

  filterActionFrom() {
    if (this.item && this.item.actionsFrom && this.item.actionsFrom.length > 0) {
      this.singleItem = this.item.actionsFrom[0];
      for (const interaction of this.item.actionsFrom) {
        if (interaction.actionBy !== null) {
          this.interactionSummary += interaction.actionCount ? interaction.actionCount : 0;
          if (interaction.action === 'Like') {
            this.numberOfDifferentAction += 1;
          }
          if (interaction.action === 'Adopt') {
            this.numberOfDifferentAction += 1;
          }
          if (interaction.action === 'Rating') {
            this.numberOfDifferentAction += 1;
          }
          if (interaction.action === 'Comment') {
            this.numberOfDifferentAction += 1;
          }
          if (interaction.action === 'Post for team') {
            this.numberOfDifferentAction += 1;
          }
          if(interaction.action === 'CompanyFollow') {
            this.numberOfDifferentAction += 1;
          }

          this.youSeeThisBecause = this.interactionSummary > 0;
          if (this.interactionSummary !== 0) {
            this.youSeeThisBecause = true;
            if (this.interactionSummary === 1) {
              this.showMoreBtn = false;
              this.showMoreBtn = false;
            } else {
              this.showMoreBtn = true;
              this.showLessBtn = false;
            }
          }
        }
      }

      if (this.interactionSummary > 1) {
        for (const interaction of this.item.actionsFrom) {
          if (interaction.actionBy !== null) {
            this.usersInteracted.push(interaction.actionBy.id);
            this.lastInteractionType = interaction.action;
          }
        }

        if (this.usersInteracted.length > 1) {
          this.differentUsersInteracted = new Set(this.usersInteracted).size !== 1;
          this.moreInteractionsThanUsers = this.interactionSummary > this.usersInteracted.length;
          if (!this.differentUsersInteracted && this.moreInteractionsThanUsers) {
            this.differentUsersInteracted = true;
          }
        }
      }
    }
  }

  showMoreOrLess() {
    if (this.showMoreBtn === true) {
      this.showMoreBtn = false;
      this.showLessBtn = true;
    } else {
      this.showMoreBtn = true;
      this.showLessBtn = false;
    }
  }
}
